import React, { FC, useContext, useEffect, useState } from 'react'
import { useMutation } from 'react-query'
import { Skeleton } from '../../../src/content/Skeleton/Skeleton'
import { IconPremium } from '../../icons/IconPremium/IconPremium'
import { PreferenceCardContext } from '../contexts/PreferenceCardContext'
import { EmailPreferenceItem } from './PreferenceSection'
import {
    StyledExclusiveBanner,
    StyledPreferenceCard,
    StyledToggleButton,
    StyledToggleButtonGroup,
} from './PreferenceSection.styled'

interface PreferenceCardProps {
    item: EmailPreferenceItem
    isLoading: boolean
    disabled: boolean
}

export const PreferenceCard: FC<PreferenceCardProps> = ({
    item,
    isLoading,
    disabled,
}) => {
    const preferenceCardContext = useContext(PreferenceCardContext)
    const [checked, setChecked] = useState<boolean>(false)
    useEffect(() => {
        if (preferenceCardContext.defaultToggledOn === undefined) {
            setChecked(!!item.optIn)
        } else {
            setChecked(preferenceCardContext.defaultToggledOn)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [item.optIn])

    const ExclusiveBanner = disabled ? (
        <StyledExclusiveBanner>
            <IconPremium />
            <span>Subscriber exclusive</span>
        </StyledExclusiveBanner>
    ) : null

    const toggleHandler = useMutation(
        'toggle-email-preference',
        async (value: boolean) => {
            await preferenceCardContext.toggleHandler(value, item)
            setChecked(value)
        },
    )

    return (
        <StyledPreferenceCard>
            <div>
                {ExclusiveBanner}
                <small>{item.frequency}</small>
                <h3>{item.name}</h3>
                <p>{item.description}</p>
            </div>
            <StyledToggleButtonGroup disabled={disabled && !checked}>
                <small>Opt-in</small>
                {isLoading ? (
                    <Skeleton height={40} width={100} />
                ) : (
                    <StyledToggleButton
                        on="yes"
                        off="no"
                        checked={checked}
                        onToggle={() => toggleHandler.mutate(!checked)}
                        loading={
                            toggleHandler.isLoading || isLoading || undefined
                        }
                        disabled={disabled && !checked}
                    />
                )}
                {toggleHandler.isError && <small>Error occurs</small>}
            </StyledToggleButtonGroup>
        </StyledPreferenceCard>
    )
}
